import { Minus } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { Flex } from '../Flex/Flex';
import { Hide } from '../Hide/Hide';
import { getPaletteColor } from '../utils/utils';
import { CloseButton } from '../CloseButton/CloseButton';
const BorderBottomFlex = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ChatHeader__BorderBottomFlex",
  componentId: "sc-1jht8x6-0"
})(["border-bottom:1px solid ", ";"], getPaletteColor('border.base'));
const HeaderButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "ChatHeader__HeaderButton",
  componentId: "sc-1jht8x6-1"
})(["background-color:", ";color:", ";padding:0;&:hover{background-color:", ";color:", ";}"], getPaletteColor('background.lightest'), getPaletteColor('text.dark'), getPaletteColor('background.light'), getPaletteColor('text.dark'));
/**
 * @public
 */
export function ChatHeader({
  children,
  onClose,
  onMinimize
}) {
  return React.createElement(BorderBottomFlex, {
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 3
  }, React.createElement(Box, null, children), React.createElement(Flex, null, onMinimize && React.createElement(Hide, {
    xs: true,
    sm: true,
    md: true
  }, React.createElement(HeaderButton, {
    IconLeft: Minus,
    onClick: onMinimize,
    mr: 2,
    "data-testid": 'chat-header-minimize-button'
  })), React.createElement(CloseButton, {
    onClick: onClose,
    "data-testid": 'chat-header-close-button'
  })));
}